import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'

const isSmallScreen = (width: Breakpoint) => width === 'xs' || width === 'sm'
const getIsTinyScreen = (width: Breakpoint) => width === 'xs'

export { isSmallScreen, getIsTinyScreen }
